"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var duplex_buffer_stream_1 = __importDefault(require("../utils/duplex-buffer-stream"));

var events_1 = require("events");

var RemoteExec = function (_super) {
  __extends(RemoteExec, _super);

  function RemoteExec(_sessionId, socket, _code) {
    if (_sessionId === void 0) {
      _sessionId = '123';
    }

    if (_code === void 0) {
      _code = 0;
    }

    var _this = _super.call(this) || this;

    _this._sessionId = _sessionId;
    _this.socket = socket;
    _this._code = _code;
    _this.stdout = new duplex_buffer_stream_1.default();
    _this.stderr = new duplex_buffer_stream_1.default();
    _this.stdin = new duplex_buffer_stream_1.default();
    return _this;
  }

  Object.defineProperty(RemoteExec.prototype, "sessionId", {
    get: function get() {
      return this._sessionId;
    },
    enumerable: true,
    configurable: true
  });

  RemoteExec.prototype.setStatus = function (status) {
    this._code = status;
    this.emit('close');
  };

  Object.defineProperty(RemoteExec.prototype, "code", {
    get: function get() {
      return this._code;
    },
    enumerable: true,
    configurable: true
  });

  RemoteExec.prototype.resize = function (rows, columns) {
    this.socket.emit("terminal." + this._sessionId + ".resize", rows, columns);
  };

  RemoteExec.prototype.inspect = function () {
    return Promise.resolve({
      running: true,
      pid: Number(this._sessionId)
    });
  };

  RemoteExec.prototype.abort = function () {
    return Promise.resolve();
  };

  return RemoteExec;
}(events_1.EventEmitter);

exports.RemoteExec = RemoteExec;